
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iFaMg", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_NOT_IN_NAV", () => $2834702a20a1816a$export$d34bba8c7068f876);
$parcel$export(module.exports, "autoAdjustPosition", () => $2834702a20a1816a$export$8005c110df91a313);
$parcel$export(module.exports, "OnboardingNudgeComponent", () => $2834702a20a1816a$export$96dfbdc3eda1cd3a);
$parcel$export(module.exports, "OnboardingNudge", () => $2834702a20a1816a$export$c09847f3a2ea8c56);

var $gwFzn = parcelRequire("gwFzn");

var $gR84W = parcelRequire("gR84W");

var $dTk3A = parcelRequire("dTk3A");

var $inPa6 = parcelRequire("inPa6");

var $7Sm4c = parcelRequire("7Sm4c");

var $gfIPU = parcelRequire("gfIPU");
var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $dIouf = parcelRequire("dIouf");

var $id4ij = parcelRequire("id4ij");

var $huBE1 = parcelRequire("huBE1");
const $2834702a20a1816a$export$d34bba8c7068f876 = {};
const $2834702a20a1816a$export$8005c110df91a313 = (fn, { interval: interval = 500, cycles: cycles = 10 })=>{
    let i = 0;
    const timer = setInterval(()=>{
        fn?.();
        i++;
        if (i === cycles) clearInterval(timer);
    }, interval);
    return timer;
};
function $2834702a20a1816a$var$isErrorHandled(error) {
    // Mark unauthorized error as handled and not report to monitoring client
    if ((0, $dIouf.isUnauthorizedError)(error) || error?.graphQLErrors?.[0]?.message === 'unauthorized') {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    return false;
}
const $2834702a20a1816a$export$96dfbdc3eda1cd3a = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { hidden: hidden, children: children, source: source, actionSubjectId: actionSubjectId, heading: heading, content: content, width: width = 320, wrapper: wrapper, zIndex: zIndex = (0, $dTk3A.layers).blanket(), position: position, offset: offset, onShow: onShow, onHide: onHide, onClick: onClick, onOutsideClick: onOutsideClick, onboardingErrors: onboardingErrors } = props;
    const Wrapper = wrapper || (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment;
    const target = `onboarding-nudge-${actionSubjectId}`;
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const nudgeSpotlightRef = (0, $gwFzn.useRef)(null);
    // used to turn off effects for outsideClick
    const [outsideClicked, setOutsideClicked] = (0, $gwFzn.useState)(false);
    /**
	 * The point of this local hidden is to hide the nudge when the element is no longer in view
	 * This local hidden value is then changed when the element is back in view.
	 */ const [isLocalHidden, setIsLocalHidden] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (!hidden) experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_NUDGE_EXPERIENCE)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hidden,
        experienceTracker
    ]);
    // Scroll fix for nudges that will be covered by global nav
    (0, $gwFzn.useEffect)(()=>{
        let isScrolling;
        const handleMouse = ()=>{
            isScrolling && window.clearTimeout(isScrolling);
            isScrolling = setTimeout(()=>{
                const element = document.getElementById(target);
                if (!element) return;
                let elementInViewport = (0, $id4ij.isElementInViewport)(element);
                // Elements not in the nav bar sometimes get hidden by the nav bar
                elementInViewport = element.getBoundingClientRect().top > 40;
                setIsLocalHidden(!elementInViewport);
            }, 250);
        };
        if (!hidden) window.addEventListener('scroll', handleMouse, true);
        return ()=>{
            window.removeEventListener('scroll', handleMouse, true);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hidden,
        outsideClicked
    ]);
    // Timer to account for lazily loaded components and to update tooltip position with a force rerender
    (0, $gwFzn.useEffect)(()=>{
        let timer;
        if (!hidden && nudgeSpotlightRef && nudgeSpotlightRef.current) timer = $2834702a20a1816a$export$8005c110df91a313(nudgeSpotlightRef?.current?.forceUpdateCardPosition, {
            interval: 500,
            cycles: 10
        });
        return ()=>{
            clearInterval(timer);
        };
    }, [
        nudgeSpotlightRef,
        hidden
    ]);
    // ------ Behavioral Callbacks ------
    const handleOnHide = ()=>{
        (0, $huBE1.fireEvent)(createAnalyticsEvent, {
            type: 'sendTrackEvent',
            source: source,
            actionSubjectId: actionSubjectId,
            actionSubject: 'nudgeTooltip',
            action: 'hidden'
        });
        onHide?.();
    };
    const handleOnClick = ()=>{
        (0, $huBE1.fireEvent)(createAnalyticsEvent, {
            type: 'sendTrackEvent',
            source: source,
            actionSubjectId: actionSubjectId,
            actionSubject: 'nudgeTooltip',
            action: 'clicked'
        });
        onClick?.();
        experienceTracker.succeed({
            name: (0, $irVI7.ONBOARDING_NUDGE_EXPERIENCE)
        });
    };
    const handleOnShow = ()=>{
        (0, $huBE1.fireEvent)(createAnalyticsEvent, {
            type: 'sendTrackEvent',
            source: source,
            actionSubjectId: actionSubjectId,
            actionSubject: 'nudgeTooltip',
            action: 'shown'
        });
        onShow?.();
    };
    const handleOnOutsideClick = ()=>{
        onOutsideClick?.();
        setOutsideClicked(true);
    };
    // If there is a known error it should not display the nudge the priority of error is higher than hidden
    if (onboardingErrors && onboardingErrors.length) {
        const ErrorDisplays = onboardingErrors.filter((error)=>{
            return !$2834702a20a1816a$var$isErrorHandled(error);
        }).map((error)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
                error: error,
                key: error.message
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gfIPU.ExperienceFailure), {
                name: (0, $irVI7.ONBOARDING_NUDGE_EXPERIENCE),
                error: error,
                key: error.message,
                attributes: {
                    source: source,
                    actionSubjectId: actionSubjectId
                }
            }));
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children, ErrorDisplays);
    }
    return hidden || isLocalHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gR84W.NudgeSpotlight), {
        ...props,
        ref: nudgeSpotlightRef,
        heading: heading,
        content: content,
        width: width,
        hidden: hidden || isLocalHidden,
        hideNudgeOnClick: true,
        hideSpotlightCardOnOutsideClick: true,
        onHide: handleOnHide,
        onShow: handleOnShow,
        onClick: handleOnClick,
        onOutsideClick: handleOnOutsideClick,
        zIndex: zIndex,
        position: position,
        offset: offset
    }, children));
};
const $2834702a20a1816a$export$c09847f3a2ea8c56 = (props)=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const failedOnboardingNudge = (0, $gwFzn.useCallback)((error)=>{
        experienceTracker.fail({
            name: (0, $irVI7.ONBOARDING_NUDGE_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.GenericErrorBoundary), {
        attribution: (0, $dIouf.Attribution).FLYWHEEL_ADOPTION,
        onError: failedOnboardingNudge,
        renderOnError: ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, props.children);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($2834702a20a1816a$export$96dfbdc3eda1cd3a, props));
};

});
parcelRegister("gfIPU", function(module, exports) {

$parcel$export(module.exports, "ExperienceFailure", () => $5675860ef242c9e4$export$eed1d73ebdd8c7ab);

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");
function $5675860ef242c9e4$export$eed1d73ebdd8c7ab({ name: name, error: error, attributes: attributes }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $gwFzn.useEffect)(()=>experienceTracker.fail({
            name: name,
            error: error,
            attributes: attributes
        }), [
        experienceTracker,
        name,
        error,
        attributes
    ]);
    return null;
}

});

parcelRegister("id4ij", function(module, exports) {

$parcel$export(module.exports, "getElementTop", () => $21c1903a8ac50cbe$export$f25538161b7e9c17);
$parcel$export(module.exports, "isElementInViewport", () => $21c1903a8ac50cbe$export$7cc0e9dd2435cb30);
$parcel$export(module.exports, "scrollElementToViewCenter", () => $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2);
$parcel$export(module.exports, "getElementBounds", () => $21c1903a8ac50cbe$export$abe5643cba19555f);
$parcel$export(module.exports, "isPartOfElementStillInViewPort", () => $21c1903a8ac50cbe$export$4c0864c7defafad3);
$parcel$export(module.exports, "isTopOfElementStillInViewPort", () => $21c1903a8ac50cbe$export$4acade851e875ad4);
$parcel$export(module.exports, "replaceDomElementContent", () => $21c1903a8ac50cbe$export$5513bf0589d602a4);
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || document.scrollingElement || document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        document.body.appendChild(el);
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}

});

parcelRegister("huBE1", function(module, exports) {

$parcel$export(module.exports, "fireEvent", () => $a1b66a9372b16102$export$43835e9acf248a15);
const $a1b66a9372b16102$var$COMPONENT_NAME = 'nudgeTooltip';
const $a1b66a9372b16102$export$43835e9acf248a15 = (createAnalyticsEvent, { contentId: contentId, actionSubjectId: actionSubjectId, actionSubject: actionSubject, source: source, action: action, type: type, attributes: attributes })=>{
    createAnalyticsEvent({
        type: type,
        data: {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            source: source,
            attributes: {
                ...contentId ? {
                    contentId: contentId
                } : {},
                nudgeTarget: actionSubjectId,
                componentName: $a1b66a9372b16102$var$COMPONENT_NAME,
                ...attributes
            }
        }
    }).fire();
};

});


parcelRegister("dH6p2", function(module, exports) {

$parcel$export(module.exports, "NudgeTooltipPulse", () => $ad7aee5d47af256f$export$2d11151259bb3b10);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $dTk3A = parcelRequire("dTk3A");
var $6fnsQ = parcelRequire("6fnsQ");

var $dh538 = parcelRequire("dh538");
const $ad7aee5d47af256f$var$baseShadow = '0 0 0 3px';
const $ad7aee5d47af256f$var$basePulseColor = `var(--ds-border-accent-purple, ${(0, $6fnsQ).P75})`;
const $ad7aee5d47af256f$var$basePulseShadowColor = "var(--ds-border-accent-purple, rgba(101, 84, 192, 1))";
const $ad7aee5d47af256f$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $ad7aee5d47af256f$var$pulseAnimation = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes pulseKeyframes': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 0
        }
    },
    animationName: 'pulseKeyframes',
    animationDuration: '3000ms',
    animationTimingFunction: $ad7aee5d47af256f$var$easing,
    animationIterationCount: 'infinite'
});
const $ad7aee5d47af256f$var$pseudoStyle = (0, $3jLHL.css)({
    content: "''",
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
});
const $ad7aee5d47af256f$export$814d9bf8c56ac913 = ({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor })=>(0, $3jLHL.css)({
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> *': {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::before': [
                $ad7aee5d47af256f$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$ad7aee5d47af256f$var$baseShadow} ${pulseColor}`,
                    opacity: hasPulse ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: 'none'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::after': [
                $ad7aee5d47af256f$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$ad7aee5d47af256f$var$baseShadow} ${pulseColor}, 0 0 11px ${pulseShadowColor}`,
                    opacity: 0,
                    pointerEvents: 'none'
                },
                hasPulse && $ad7aee5d47af256f$var$pulseAnimation
            ]
        }
    });
const $ad7aee5d47af256f$export$2d11151259bb3b10 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius = (0, $dTk3A.borderRadius)(), pulseColor: pulseColor = $ad7aee5d47af256f$var$basePulseColor, pulseShadowColor: pulseShadowColor = $ad7aee5d47af256f$var$basePulseShadowColor, tag: TargetContainer = 'span', ...rest }, ref)=>{
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    return /*#__PURE__*/ (0, $3jLHL.jsx)(CastTargetContainer, {
        css: [
            $ad7aee5d47af256f$export$814d9bf8c56ac913({
                hasPulse: hasPulse,
                pulseBorderRadius: pulseBorderRadius,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor
            }),
            (0, $dh538.fg)('jira_onboarding_experiences_a11y_fixes') && $ad7aee5d47af256f$var$inHeritWidthStyles
        ],
        ref: ref,
        ...rest
    });
});
const $ad7aee5d47af256f$var$inHeritWidthStyles = (0, $3jLHL.css)({
    width: 'inherit'
});

});


//# sourceMappingURL=OnboardingNudgeTooltip.d560d3e3.js.map
